/* eslint-disable no-barrel-files/no-barrel-files */

import { KestrelModelResultCard } from 'features/search/components/resultCards/KestrelModelResultCard'
import { RolodexEntryType } from 'types'

import { DefaultResultCard, ResultCardProps } from './DefaultResultCard'
import { UnitResultCard } from './UnitResultCard'

export type ResultCardComponent = React.FC<ResultCardProps>

export const RESULT_CARD_REGISTRY: Partial<
  Record<RolodexEntryType, ResultCardComponent>
> = {
  [RolodexEntryType.UNIT]: UnitResultCard,
  [RolodexEntryType.KESTREL_MODEL]: KestrelModelResultCard,
}

export const getResultCardComponent = (
  type: RolodexEntryType
): ResultCardComponent => {
  return RESULT_CARD_REGISTRY[type] || DefaultResultCard
}

export { DefaultResultCard, UnitResultCard }
export type { ResultCardProps }
